import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SisWorkflowClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/workflow');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Workflow');
    }
  }

  async findByTipoWorkflow(workflowtipoid) {
    try {
      const { data } = await this.api.get(`/workflow/findByTipoWorkflow/${workflowtipoid}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Workflow');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/workflow', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Workflow');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/workflow', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as  Workflow');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/workflow/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a  Workflow');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/workflow', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a  Workflow');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/workflow/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a  Workflow');
    }
  }
}
